import { FC, ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'
import useCurrentPath from '../../../hooks/useCurrentPath'
import useRootColor from '../../../hooks/useRootColor'

type Props = {
  urlPath: string
  children?: ReactElement
}

const LinkButton: FC<Props> = (props) => {
  const { urlPath, children } = props
  const navigate = useNavigate()
  const { bgColor, baseColor } = useRootColor()
  const { currentPath } = useCurrentPath()

  return (
    <button
      type="button"
      onClick={() => navigate(urlPath)}
      style={{
        backgroundColor: currentPath.includes(urlPath) ? baseColor : bgColor,
        border: 'solid .1rem',
        borderColor: baseColor,
      }}
    >
      {children}
    </button>
  )
}

export default LinkButton
